import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

export const formatPrice = (n) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: 0 }).format(n);

export const variantLabel = (item) =>
  [item.color, item.size && `Size ${item.size}`].filter(Boolean).join(" · ");

export const logger = {
  error: (msg, err) => {
    if (process.env.NODE_ENV !== "production") {
      console.error(`[capra] ${msg}`, err);
    }
  },
};
